import React from 'react';
import { Toaster } from '../../components/ui/sonner';
import { PasswordLogin } from './PasswordLogin';
import { ArrowRight, Compass, Target, Hammer, MessageSquareHeart } from 'lucide-react';

const STEPS = [
  { icon: Compass, t: 'Where you stand', d: 'Readiness Check + consultation' },
  { icon: Target, t: 'Where you want to go', d: 'Target roles & employer expectations' },
  { icon: Hammer, t: 'Practical tasks', d: 'Reviewed by expert consultants' },
  { icon: MessageSquareHeart, t: 'Weekly support', d: 'Human check-ins that adapt your plan' },
];

const startLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + window.location.pathname;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const isDemo = () => window.location.pathname.startsWith('/demo');

export const JourneyLogin = ({ onLogin }) => (
  <div className="min-h-screen bg-[#0b1f4d] text-white flex items-center" data-testid="journey-login">
    <Toaster position="top-center" richColors />
    <div className="max-w-6xl mx-auto px-6 py-16 grid lg:grid-cols-[1.2fr_1fr] gap-14 items-center w-full">
      <div className="jr-rise">
        <p className="text-xs tracking-[0.25em] uppercase text-teal-300 mb-6" data-testid="journey-login-eyebrow">{isDemo() ? 'Elevate Careers · Prototype preview' : 'Elevate Careers · Student dashboard'}</p>
        <h1 className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight">
          Your adaptive<br />career journey.
        </h1>
        <p className="mt-6 text-base text-slate-300 max-w-lg leading-relaxed">
          Expert diagnosis, a personalised plan for your target roles, practical tasks reviewed by Elevate consultants, and weekly support.
        </p>
        <div className="mt-10 max-w-sm space-y-4" data-testid="journey-login-options">
          {isDemo() && <>
          <button onClick={startLogin} data-testid="journey-google-login-btn"
              className="w-full inline-flex items-center justify-center gap-3 bg-white text-[#0b1f4d] font-semibold px-7 py-3.5 rounded-full hover:bg-teal-50 transition-colors">
              <img src="https://www.google.com/favicon.ico" alt="" className="w-5 h-5" /> Continue with Google <ArrowRight className="w-4 h-4" />
            </button>
            <div className="flex items-center gap-3 text-xs text-slate-400"><span className="h-px flex-1 bg-white/15" />or sign in with your email and password<span className="h-px flex-1 bg-white/15" /></div>
          </>}
          <PasswordLogin onDone={onLogin} />
        </div>
        <p className="mt-5 text-xs text-slate-400">Use the email you joined the Talent Network with. Not joined yet? <a href="/network" className="text-teal-300 font-semibold" data-testid="journey-join-network-link">Join the Talent Network</a></p>
        {isDemo() && <p className="mt-2 text-xs text-slate-500" data-testid="journey-login-prototype-note">Prototype: payments are simulated. No real money is collected.</p>}
      </div>
      <div className="grid grid-cols-2 gap-3">
        {STEPS.map(({ icon: Icon, t, d }, i) => (
          <div key={t} className="jr-rise rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur" style={{ animationDelay: `${120 + i * 90}ms` }}>
            <Icon className="w-5 h-5 text-teal-300 mb-4" />
            <p className="font-outfit font-semibold">{t}</p>
            <p className="text-sm text-slate-400 mt-1">{d}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);
